const REDUX_SORT_KEY = {}
export default REDUX_SORT_KEY
